import ExtendedLink from "./ExtendedLink";
import Image from "./Image";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function ConsultantCard(props) {
    const { t } = useTranslation();
    const { consultant, settings, className, contactConsultantHandler } = props;


    const onContactConsultant = (e) => {
        e.preventDefault();
        contactConsultantHandler(consultant.id, consultant.name, consultant.email, consultant.fullPictureUrl)
    }
    const onAdClick = (e) => {
        e.preventDefault();
        window.open(settings.resultAdUrlNearbyConsultant || "", "_blank", "noreferrer");
    }

    const consultantImage = consultant.fullPictureUrl ? consultant.fullPictureUrl : "img/account/default-user-ava.png";

    return (
        <Fragment>
            {!props.isHorizontal && (

                <div className={className}>

                    <div className="d-table" style={{ tableLayout: "fixed", width: "100%" }}>
                        <div className="d-table-cell epr-card-avatar-container">
                            <div className="epr-card-avatar rounded-circle" style={{ backgroundImage: `url(${encodeURI(consultantImage)})` }} title={consultant.name}></div>
                        </div>
                        {!consultant.isResultAd && <div className="pl-3 d-table-cell align-middle">
                            <h6>{consultant.name}</h6>
                            <i className="pe-7s-call mr-1"></i>
                            {(consultant.phone || consultant.mobile) &&
                                <Fragment>
                                    {(consultant.phone !== consultant.mobile && consultant.phone && consultant.mobile) ?

                                        <Fragment>
                                            <a className="text-decoration-none text-muted mb-2" href={`tel:${consultant.phone.replace(/\s/g, "")}`} target="_top" rel="noopener noreferrer">{consultant.phone.replace(/\s/g, "")}</a>
                                            {/* <span className="text-decoration-none text-muted mb-2">, </span> */}
                                            <div>
                                                <i className="pe-7s-call mr-1"></i>
                                                <a className="text-decoration-none text-muted mb-2" href={`tel:${consultant.mobile.replace(/\s/g, "")}`} target="_top" rel="noopener noreferrer">{consultant.mobile.replace(/\s/g, "")}</a>
                                            </div>
                                        </Fragment>
                                        :

                                        (consultant.mobile) ?
                                            <a className="text-decoration-none text-muted mb-2" href={`tel:${consultant.mobile.replace(/\s/g, "")}`} target="_top" rel="noopener noreferrer">{consultant.mobile.replace(/\s/g, "")}</a>
                                            :
                                            (consultant.phone ?
                                                <a className="text-decoration-none text-muted mb-2" href={`tel:${consultant.phone.replace(/\s/g, "")}`} target="_top" rel="noopener noreferrer">{consultant.phone.replace(/\s/g, "")}</a>
                                                :
                                                ""
                                            )
                                    }
                                </Fragment>
                            }
                            <p className=" text-muted w-350 text-truncate mb-0">
                                <i className="pe-7s-mail mr-1"></i>
                                <a className="text-decoration-none text-muted" target="_top" rel="noopener noreferrer" href={`mailto:${consultant.email}`} title={consultant.email}>{consultant.email}</a>
                            </p >
                            {consultant.address4 &&
                                <p className="text-decoration-none text-muted mb-2">
                                    <i className="pe-7s-map-marker mr-1"></i>
                                    {consultant.address4}
                                </p>
                            }
                            <div className="social-bar">
                                <a className="btn btn-secondary btn-sm text-center " onClick={onContactConsultant} >
                                    {(settings.isPluginMode || settings.isCatalogueMode || settings.isSearcPluginMode) ? t("Contact Me") : t("Register With Consultant")}
                                </a>
                            </div>
                        </div>}

                        {consultant.isResultAd && <div className="pl-3 d-table-cell align-middle">
                            <h3 style={{ marginBottom: "6px", fontSize: "18px", lineHeight: "1.25", fontWeight: "bold" }}>
                                {t("No EPRs In Range Message")}
                            </h3>
                            <div className="social-bar">
                                <a className="btn btn-secondary btn-sm text-center " style={{ minWidth: "170px" }} onClick={onAdClick} >
                                    {t("Join Us")}
                                </a>
                            </div>
                        </div>}
                    </div>
                </div>
            )}

            {props.isHorizontal && (
                <div className={className}>
                    <div className="card text-center">

                        <Image className="card-img-top" src={consultantImage}
                            fallbackSrc="img/account/default-user-ava.png" alt={consultant.name} />

                        <div className="card-body">
                            <h5 className="card-title mb-2">{consultant.name}</h5>
                            <p className="text-muted mb-2" >{(consultant.phone !== consultant.mobile && consultant.phone && consultant.mobile) ?
                                `${consultant.mobile} - ${consultant.phone}`
                                :
                                (consultant.mobile ? consultant.mobile : (consultant.phone ? consultant.phone : ""))}
                            </p>
                            <p className=" text-muted w-350 text-truncate mb-2">
                                <i className="pe-7s-mail mr-1"></i>
                                <a className="text-decoration-none text-muted" href={`mailto:${consultant.email}`} title={consultant.email}>{consultant.email}</a>
                            </p>
                            <div className="social-bar"></div>
                            <a className="btn btn-secondary btn-sm text-center " onClick={onContactConsultant} >
                                {(settings.isPluginMode || settings.isCatalogueMode || settings.isSearcPluginMode) ? t("Contact Me") : t("Register With Consultant")}
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
}
